export default "__VITE_ASSET__11a28345__"